<div *transloco="let t" class="flex items-center gap-2 max-lg:flex-wrap">
  <pxc-filter-bar data-testid="filter-bar" [searchPlaceholder]="t('Rechercher un fichier par nom, ou créateur...')" />
</div>
